import {LoadingButton} from '@mui/lab';
import {MenuItem, SelectChangeEvent} from '@mui/material';
import {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router';
import socket, {IResponse} from '@sockets';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import DatePickerRez from '../uikit/DatePickerRez';
import InputRez from '../uikit/InputRez';
import SelectRez from '../uikit/SelectRez';
import {IUser} from './Profile';
// import {stateCities} from '@constants/cities';
import {AppConstants} from '@constants';

export default function EditProfile() {
	const location = useLocation();
	const [user, setUser] = useState<IUser | undefined>(location.state?.user);
	const [birthDate, setBirthDate] = useState<Date | null>(location.state?.user.birthDate ? new Date(location.state?.user.birthDate) : null);
	const [loading, setLoading] = useState(false);
	const [gender, setGender] = useState(user?.gender);
	const [state, setState] = useState(user?.state);
	const [city, setCity] = useState(user?.city);
	const navigate = useNavigate();
	
	const {t} = useTranslation();
	const txtFirstname = useRef<HTMLInputElement>();
	const txtLastname = useRef<HTMLInputElement>();
	const txtUsername = useRef<HTMLInputElement>();
	const txtNationalCode = useRef<HTMLInputElement>();
	
	const handleEdit = () => {
		setLoading(true);
		socket.emit('profile:edit', {
			firstname: txtFirstname.current!.value,
			lastname: txtLastname.current!.value,
			username: txtUsername.current!.value,
			nationalCode: txtNationalCode.current!.value,
			gender,
			city,
			state,
			birthDate
		}, (data: IResponse<null>) => {
			setLoading(false);
			navigate(-1);
		});
	};
	
	const handleChangeGender = (event: SelectChangeEvent) => {
		setGender(event.target.value as IUser['gender']);
	};
	
	const handleChangeState = (event: SelectChangeEvent) => {
		setState(event.target.value);
	};
	
	const handleChangeCity = (event: SelectChangeEvent) => {
		setCity(event.target.value);
	};
	
	return (
		<div className="flex flex-col space-y-2 pb-4 h-full">
			<HeaderWithIcons title={t('profile')}/>
			<InputRez inputRef={txtFirstname} className="px-5" placeholder={t('firstname')} defaultValue={user?.firstname}/>
			<InputRez inputRef={txtLastname} className="px-5" placeholder={t('lastname')} defaultValue={user?.lastname}/>
			<InputRez inputRef={txtUsername} className="px-5" placeholder={t('username')} defaultValue={user?.username}/>
			<InputRez inputRef={txtNationalCode} className="px-5" placeholder={t('national_code')}
			          defaultValue={user?.nationalCode}/>
			<DatePickerRez className="mx-5" value={birthDate} onChange={setBirthDate}/>
			<div className="px-5">
				<SelectRez onChange={handleChangeGender} value={gender} placeholder={t('gender')}>
					<MenuItem value={'male'}>{t('male')}</MenuItem>
					<MenuItem value={'female'}>{t('female')}</MenuItem>
				</SelectRez>
			</div>
			<div className="px-5">
				<SelectRez onChange={handleChangeState} value={state} placeholder={t('state')}>
					{
						AppConstants.allStates.map(state => <MenuItem value={state.name}>{state.name}</MenuItem>)
					}
				</SelectRez>
			</div>
			{
				state && <div className="px-5">
					<SelectRez onChange={handleChangeCity} value={city} placeholder={t('city')}>
						{
							AppConstants.allStates.find(s => s.name === state)?.cities.map(city => <MenuItem value={city.id}>{city.name}</MenuItem>)
						}
					</SelectRez>
				</div>
			}
			<div className="grow"></div>
			<div className="px-5">
				<LoadingButton loading={loading} variant="contained" fullWidth onClick={handleEdit}>{t('edit')}</LoadingButton>
			</div>
		</div>
	);
}
